import { RedoFulfillmentToteSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote";
import { locationIdFormat } from "@redotech/redo-model/ids";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateTote = {
  name: "updateTote" as const,
  input: z.object({
    toteId: zExt.objectId(),
    name: z.string().optional(),
    toteGroupId: zExt.objectId().nullish(),
    locationId: locationIdFormat.schema.nullish(),
  }),
  output: RedoFulfillmentToteSchema,
};
